module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/common-module/components/simple-product-list/simple-product-list.component.scss
// module id = ./src/app/modules/common-module/components/simple-product-list/simple-product-list.component.scss
// module chunks = 9